export default "__VITE_ASSET__CiAw9O_U__"